<template>
  <main>
    <PageIntro
      :heading="
        'Link Your <span>' +
        configStrings.clubName +
        ' ' +
        configStrings.productName +
        '</span>'
      "
      :body="''"
    />
    <div v-if="addressComplete === true">
      <UserProfileSeatgeekLink
        v-on:link-update="userProfileSeatgeekLinkResponse"
      />
    </div>
    <div v-if="addressComplete === false">
      <UserProfileAddress v-on:address-update="userProfileAddressResponse" />
    </div>
  </main>
</template>

<script>
import UserProfileSeatgeekLink from "@/components/UserProfileSeatgeekLink.vue";
import UserProfileAddress from "@/components/UserProfileAddress.vue";
import PageIntro from "@/components/PageIntro";

export default {
  components: {
    UserProfileSeatgeekLink,
    UserProfileAddress,
    PageIntro,
  },
  data() {
    return {
      addressComplete: null,
      linkComplete: false,
    };
  },
  mounted() {
    // check if address is complete

    this.$getCurrentUserAttributes().subscribe((userData) => {
      var address = JSON.parse(userData["address"]);

      if (
        address["street_address"] &&
        address["postal_code"] &&
        address["country"]
      ) {
        this.addressComplete = true;
      } else {
        this.addressComplete = false;
      }
    });
  },
  methods: {
    userProfileAddressResponse(value) {
      if (value === "complete") {
        this.addressComplete = true;
      }
    },
    userProfileSeatgeekLinkResponse(value) {
      if (value === "complete") {
        this.linkComplete = true;
        this.redirectUser();
      }
    },
    redirectUser(e) {
      if (localStorage.returnUrl) {
        var redirectLocation = localStorage.returnUrl
          .substring(8)
          .split(".")[0];
        var redirectAlert = "";
        // if they were from a trusted referrer and we need to send them back with a JWT
        if (redirectLocation === "shop") {
          redirectAlert = "You are being redirected to the Online Store";
        } else if (redirectLocation === "tickets") {
          redirectAlert = "You are being redirected to the Ticketing website";
        } else if (redirectLocation === "video") {
          redirectAlert = "You are being redirected to Villa TV";
        } else if (redirectLocation === "rewards") {
          redirectAlert = "You are being redirected to the Rewards website";
        } else if (redirectLocation === "avfc") {
          redirectAlert =
            "You are being redirected to the Official Club website";
        } else {
          redirectAlert = "You are being redirected to the referring platform";
        }

        alert(redirectAlert);
        var authUser = this.$getAuthenticatedUser();
        authUser.getSession(function (err, session) {
          //
          var jwtToken = session.getIdToken().getJwtToken();
          if (localStorage.responseType == "post") {
            var form = document.createElement("form");
            document.body.appendChild(form);
            form.method = "post";
            form.action = localStorage.returnUrl;
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "token";
            input.value = jwtToken;
            form.appendChild(input);

            localStorage.removeItem("returnUrl");
            localStorage.removeItem("suppressToken");
            localStorage.removeItem("responseType");
            form.submit();
          } else {
            var firstQueryChar = "?";
            if (localStorage.returnUrl.includes("?")) {
              // account for ? in string
              firstQueryChar = "&";
            }
            var redirect = localStorage.returnUrl;
            if (!localStorage.suppressToken) {
              redirect = redirect + firstQueryChar + "token=" + jwtToken;
            }

            localStorage.removeItem("returnUrl");
            localStorage.removeItem("suppressToken");
            localStorage.removeItem("responseType");
            window.location = redirect;
          }
        });
      }
    },
  },
};
</script>
